import * as React from 'react';

export const useScrollDetection = ({
  ref,
  offset,
  cb,
  dep,
}: {
  ref: React.RefObject<any>;
  offset: number;
  cb(isState: boolean): void;
  dep?: any[];
}) => {
  const currentState = React.useRef(false);
  React.useEffect(() => {
    if (!ref.current) {
      cb(false);
      return;
    }
    const handleScroll = () => {
      const top = ref.current.getBoundingClientRect().top;
      const newState = top === offset || top < 0;
      if (newState !== currentState.current) {
        currentState.current = newState;
        cb(currentState.current);
      }
    };
    document.addEventListener('scroll', handleScroll);
    return () => {
      document.removeEventListener('scroll', handleScroll);
    };
  }, dep ?? []);
};
